<template>
    <div class="container">
        <div class="culture">
            <h2 class="culture-title" v-if="COMMON.isMobile">安得文化</h2>
            <div class="part">
                <img src="../../images/picture/culture_1_mobile.png" v-if="COMMON.isMobile">
                <img src="../../images/picture/culture_1.jpg" v-else>
                <div class="culture-content">
                    <h4>企业愿景</h4>
                    <p>致力于成为中国最值得信赖的供应链（物流）合作伙伴</p>
                    <p class="label-text">共建、共创、共享</p>
                </div>
            </div>
            <div class="part float">
                <img class="right" src="../../images/picture/culture_2_mobile.png" v-if="COMMON.isMobile">
                <img class="right" src="../../images/picture/culture_2.jpg" v-else>
                <div class="culture-content">
                    <h4>企业使命</h4>
                    <p>以供应链服务为伙伴创造多一份价值</p>
                    <p class="label-text">专业、信赖、价值</p>
                </div>
            </div>
            <div class="part">
                <img src="../../images/picture/culture_3_mobile.jpg" v-if="COMMON.isMoblie">
                <img src="../../images/picture/culture_3.jpg" v-else>
                <div class="culture-content">
                    <h4>价值观</h4>
                    <p>走正路、走远路</p>
                    <p>变革者、创业者</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'culture',
    components: {},
    metaInfo: {
        title: '安得文化-安得智联'
    }
};
</script>

<style lang="less">
.culture {
    padding-bottom: 1rem;
    .part {
        width: 100%;
        height: 3.54rem;
        background-color: #fafafa;
        display: flex;
        margin: 0.6rem 0;
        &:after {
            display: block;
            content: '';
            clear: both;
            height: 0;
            visibility: hidden;
        }
        img {
            height: 100%;
            width: 5.42rem;
        }
        .right {
            float: right;
        }
    }
    .culture-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 .65rem;
        height: 100%;
        h4 {
            font-size: 20px;
            color: #ff8b00;
            line-height: 3em;
        }
        p {
            font-size: 18px;
            color: #333333;
            margin-bottom: 0.13rem;
        }
        .label-text {
            font-size: 16px;
            color: #999999;
        }
    }
    .float {
        display: block;
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .culture .culture-content {
        h4{
            font-size: 18px;
        }
        p {
            font-size: 16px;
        }
        .label-text {
            font-size: 14px;
        }
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .culture .culture-content {
        h4{
            font-size: 16px;
        }
        p {
            font-size: 14px;
        }
        .label-text {
            font-size: 12px;
        }
    }
}

@media screen and (max-width: 480px) {
    .culture {
        padding: 0.15rem;
        .culture-title {
            font-size: 16px;
            text-align: center;
            margin: 0 0 .2rem 0 ;
            font-weight: bold;
        }
        .part {
            width: 100%;
            height: auto;
            background-color: #fff;
            display: block;
            margin: 0 0 0.15rem 0;
            box-shadow: 0 1px 5px #e2e1e1;
            padding: .1rem;
            box-sizing: border-box;
            img {
                height: auto;
                width: 100%;
            }
            .right {
                float:inherit;
            }
        }
        .culture-content {
            padding: .05rem .1rem .1rem;
            h4 {
                font-size: 14px;
                color: #ff8b00;
                margin: .1rem 0 .05rem 0;
            }
            p {
                font-size: 12px;
                color: #666666;
                margin-bottom: 0.05rem;
            }
            .label-text {
                font-size: 12px;
            }
        }
        .float {
            display: block;
        }
    }
}
</style>